import { getGraphqlClient } from "@/api/graphql/client.ts";

import { createTidLinkedAccountMutation } from "./mutations.ts";
import type { CreateTidLinkedAccountParams } from "./types.ts";

export const createTidLinkedAccount = ({
  accountId,
  linkedAccountId,
  typeId,
}: CreateTidLinkedAccountParams) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(createTidLinkedAccountMutation, {
    request: {
      accountId,
      linkedAccountId,
      typeId,
    },
  });
};
